"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HeaderTab_1 = __importDefault(require("@/components/HeaderTab"));
function IFFUsersHeader() {
    return (react_1.default.createElement(HeaderTab_1.default, { title: "IFF Users" }));
}
exports.default = IFFUsersHeader;
